// TODO list
//	 - Prijs id uit googelen
//	 - Prijs vanaf prijs onder volume
//	 - Toon in titel de gekozen size
//	 - Discount tonen en toepassen
//	 - Toon in samenvatting gekoze size
//	 - Toon in samenvatting prijs info basic

class Book2 {
	constructor(csrf, locationId) {
		let now = new Date();

		this.config = {
			csrf: csrf,
			doCheck: false, // For debug, disable for go to wizard
			maxM3: 30,
			locationId: locationId,
		}
		this.el = {
			calStartDate: document.getElementById('js-cal_start_date'),
			sizeList: document.querySelector('#size_list'),
			form: document.querySelector('form'),
			stepList: document.querySelectorAll('#flow section'),
			stepBtnTop: document.querySelectorAll('#flow button.step__head'),
			stepBtnNext: document.querySelectorAll('#flow button.btn-next'),
			summaryNext: document.querySelector('.summary .btn-next'),
			userSelectAccount: document.querySelector('#businessField select'),
			userErr: document.getElementById('errMsg'),
			codeFieldList: document.querySelectorAll('#codeBox input'),
			codeBtnResend: document.getElementById('resend'),
		}
		this.state = {
			currentStep: 1, // TODO restore
			// currentStep: 5,
			processStep: 0,
			// Render
			renderSize: false,
			renderExtra: false,
			renderUser: false,
			isSend: false,

			codeCheckCode: null,

			codeSendCount: 0,
			codeSendLast: null,
		}
		this.val = {
			// Form data
			// startDate: null,
			// size: null,
			floor: null,
			positionId: null,
			// priceId: null,
			// TODO restore ^^^

			priceId: 587,
			startDate: new Date('2026-09-22'),
			// size: 10.1,
			size: 10,
		}
		this.json = {
			place: null,
			price: null,
			article:null,
			insurgent: null,
			created: null,
		}
	}

	init() {
		this.setListener();
		this.render();
		this.calendar();
	}

	setListener() {
		// this.field.package.addEventListener('change', this.onFieldChange.bind(this));
		this.el.form.addEventListener('submit', function (e){
			e.preventDefault();
		}.bind(this));

		this.el.stepBtnTop.forEach((it) => {
			let itStep = parseInt(it.parentElement.dataset.step);
			it.addEventListener('click', (e) => {
				this.actionGoToStep(itStep);
			})
		})
		this.el.stepBtnNext.forEach((it) => {
			let itStep = parseInt(it.parentElement.parentElement.dataset.step);
			it.addEventListener('click', (e) => {
				this.actionGoToStep(itStep + 1);
			})
		})
		this.el.summaryNext.addEventListener('click', (e) => {
			this.actionGoToStep(this.state.currentStep + 1);
		})

		// User
		this.el.userSelectAccount.addEventListener('change', (e) => {
			this.renderUser();
		});

		// Code input
		this.actionCheckCode();
		this.el.codeFieldList.forEach((el,i)=>{
			el.addEventListener('input',()=>{
				el.value = el.value.replace(/\D/g,'');
				if(el.value && i<5) this.el.codeFieldList[i+1].focus();
				this.actionCheckCode();
			});
			el.addEventListener('keydown',e=>{ if(e.key==='Backspace' && !el.value && i>0) this.el.codeFieldList[i-1].focus(); });
			el.addEventListener('paste',e=>{
				const txt=(e.clipboardData.getData('text')||'').replace(/\D/g,'').slice(0,6);
				if(txt.length){e.preventDefault();txt.split('').forEach((c,j)=>{if(this.el.codeFieldList[j])this.el.codeFieldList[j].value=c;});
					this.actionCheckCode();
				}
			});
		});
		this.el.codeBtnResend.addEventListener('click', this.actionResendCode.bind(this));
		document.addEventListener('translationsSwitchLanguage', (event) => {
			this.render();
		});
	}

	onFieldChange(e) {
	}

	// Render
	render() {
		this.renderStep();
		this.renderDate();
		this.renderSize();
		if(this.state.currentStep === 3) {
			this.renderPackage();
		}
		if(this.state.currentStep === 4) {
			this.renderExtra();
		}
		if(this.state.currentStep === 5){
			this.renderUser();
		}
		if(this.state.currentStep === 6){
			this.renderCode();
		}
		this.renderSummary();
	}

	renderStep() {
		this.el.stepList.forEach(it => {
			it.classList.remove('is-done');
			it.classList.remove('is-open');
			it.classList.remove('is-locked');

			let itStep = parseInt(it.dataset.step)
			if(itStep === this.state.currentStep) {
				it.classList.add('is-open');
			} else if(itStep < this.state.currentStep) {
				it.classList.add('is-done');
			} else {
				it.classList.add('is-locked');
			}
		});
	}

	renderDate(){
		let titleN = document.getElementById('js-step-1-title-n');
		let titleC = document.getElementById('js-step-1-title-c');
		console.log(window._language.getLanguageCode());
		if(this.val.startDate){
			titleC.innerText =  this.val.startDate.toLocaleDateString(window._language.getLanguageCode(), {day:'numeric',month:'long', year: "numeric"});
			titleC.style.display = '';
			titleN.style.display = 'none';
		} else {
			titleN.style.display = '';
			titleC.style.display = 'none';
		}
	}

	renderSize() {
		if(this.state.renderSize){
			return;
		}
		this.state.renderSize = true;
		this.el.sizeList.innerHTML = '';

		// Build list
		for (let i = 0; i < this.json.place.length; i++) {
			let it = this.json.place[i];
			let el = document.createElement('button');
			el.type = 'button';
			el.classList.add('size');
			el.innerHTML =
				(it.available < 2 ? `<span class="tag last">Laatste box</span>` : '')
				+`<span class="size__stage">`
				+`<img src="/image/promo/volume-c/${it.volume_img > this.config.maxM3 ? this.config.maxM3 : it.volume_img}m3.png">`
				+`<span class="door" style="--w:63;--h:53"></span>`
				+`</span>`
				// +`<span class="size__m2">2 m²</span>`
				+`<span class="size__m3">${it.volume} m³ inhoud</span>`
				+`<span class="size__price">${it.low_price ? it.low_price : '-'} <small>p/m</small></span>`;
			el.addEventListener('click',function (e) {
				this.el.sizeList.querySelectorAll('.active').forEach(it => it.classList.remove('active'));
				el.classList.add('active');
				this.val.size = it.volume;
				this.actionGoToStep(this.state.currentStep + 1, 100);
			}.bind(this));

			this.el.sizeList.appendChild(el);
		}
	}

	renderPackage(){
		if(!this.val.startDate || !this.val.size){
			return;
		}

		let findPriceList = null;
		findPriceList = this.json.price.find(it => {
			return parseFloat(this.val.size) === parseFloat(it.v); // fix match on int or float
		})

		if(!findPriceList){
			console.log('TODO');
		}

		// State
		let floorInput = document.querySelector('[name="floor"]:checked');
		// let positionInput = document.querySelector('[name="position"]:checked');
		let packageInput = document.querySelector('[name="package"]:checked');
		let floorVal = floorInput ? parseInt(floorInput.value) : null;
		// let positionVal = positionInput ? parseInt(positionInput.value) : null;
		let packageVal = packageInput ? parseInt(packageInput.value) : null;

		// Etage
		// - Find optionals
		let floorOptionList = [];
		// let positionOptionList = [];
		let packageOptionList = [];
		for(let i = 0; i < findPriceList['list'].length; i++){
			let it = findPriceList['list'][i];
			if(!floorOptionList.includes(it.floor)){
				floorOptionList.push(it.floor);
			}
			if(floorVal !== null && floorVal !== it.floor){
				continue;
			}

			// if(!positionOptionList.includes(it.position_id)){
			// 	positionOptionList.push(it.position_id);
			// }
			// if(positionVal !== null && positionVal !== it.position_id){
			// 	continue;
			// }

			packageOptionList.push(it);
		}
		floorOptionList.sort();

		console.log(packageOptionList, 'package');

		//
		if(!floorInput){
			let floorList = document.getElementById('floor-list');
			floorList.innerHTML = '';
			floorOptionList.forEach(function (floor){
				let el = this.createElFloor('floor', floor, 'Etage ' + floor, '', '-');
				let input = el.querySelector('input');
				input.addEventListener('change', e => this.renderPackage());
				floorList.appendChild(el);
			}.bind(this));
		}
		if(!floorInput){
			return;
		}

		// Pos
		// // if(!positionInput) {
		// 		console.log(positionOptionList, 'LIJST');
		// 	let positionList = document.getElementById('position-list');
		// 	positionList.innerHTML = '';
		// 	positionOptionList.forEach(it => {
		// 		let el = this.createElFloor('position', it, 'Positie' + it, '-', '-');
		// 		let input = el.querySelector('input');
		// 		if(it === positionVal){
		// 			input.checked  = true;
		// 		}
		// 		input.addEventListener('change', e =>  this.renderPackage());
		// 		positionList.appendChild(el);
		// 	})
		// // }

		let packageList = document.getElementById('package-list');
		packageList.innerHTML = '';
		packageOptionList.forEach(it => {
			let el = this.createElFloor('price', it.id, it.package_name, it.frequency, it.price);
			let input = el.querySelector('input');
			if(it === packageVal){
				input.checked  = true;
			}
			el.addEventListener('click', e => {
				this.val.priceId = it.id;
				console.log(e, it);
			});
			packageList.appendChild(el);
		})

	}
	renderExtra(){
		if(this.state.renderExtra){
			return;
		}
		this.state.renderExtra = true;

		// Insure
		let insuranceEl = document.getElementById('insurance');
		insuranceEl.innerHTML = '';

		let el = document.createElement('option');
		el.innerText = 'Geen verzekering';
		el.value = 0;
		insuranceEl.appendChild(el);

		for(let i = 0; i < this.json.insurgent.length; i++){
			let it = this.json.insurgent[i];
			let el = document.createElement('option');
			el.innerText = it.line;
			el.value = it.id;
			insuranceEl.appendChild(el);
		}

		// Extra articles
		let addonEl = document.getElementById('addons');
		addonEl.innerHTML = '';
		for(let i = 0; i < this.json.article.length; i++){
			let it = this.json.article[i];
			let checkbox = this.createElCheckbox(it.id, it.name, it.info, it.price_info)
			addonEl.appendChild(checkbox);
		}
	}

	renderUser(){
		let isPrivate = this.el.userSelectAccount.value === 'private';
		this.panel('#bizFields', !isPrivate);
		['business_name','business_kvk','first_name','last_name','email','zipcode', 'tel', 'house_nr','street','city'].forEach(name => {
			let it = this.$('input[name="' + name + '"]');
			let errEl = it.parentElement.querySelector('p');
			errEl = errEl ? errEl : it.parentElement.parentElement.querySelector('p');
			this.panel(errEl, false);

			if(name === 'business_name' || name === 'business_kvk'){
				if(isPrivate){
					it.required = false;
					it.minLength = null;
				} else {
					it.required = true;
					it.minLength = name === 'f_kvk' ? 8 : 2;
				}
			} else if(name === 'email'){
				it.required = true;
			} else if(name === 'tel'){
				it.required = true;
				it.minLength = 8;
			} else if(name === 'zipcode'){
				it.required = true;
				it.minLength = 4;
			} else {
				it.required = true;
				it.minLength = 2;
			}

			this.panel(this.el.userErr, false);

			if(this.state.renderUser){
				return;
			}
			it.addEventListener('blur', function(){this.renderFieldValidation(it,errEl)}.bind(this));
		});

		this.state.renderUser = true;
	}

	renderCode(){
		let previewMailEl = document.getElementById('js-preview-mail');
		previewMailEl.innerHTML = this.el.form.email.value;


	}
	renderFieldValidation(it, errEl){
		if(!it.value){
			return;
		}

		if(errEl){
			this.panel(errEl, it.value.length <= 2);
		}
	}

	renderSummary(){
		// Date
		let sumEmpty = document.querySelector('#sumEmpty');
		let sumStart = document.querySelector('#sumStart');
		this.panel(sumEmpty, !this.val.startDate);
		if(this.val.startDate){
			sumStart.innerText =  this.val.startDate.toLocaleDateString(window._language.getLanguageCode(), {day:'numeric',month:'long', year: "numeric"});
		} else {
			sumStart.innerHTML = '-';
		}

		// Price

		// Promo

		// Next button

	}

	// Action
	actionGoToStep(step, delay){
		if(this.config.doCheck){
			if(step > 1){
				if(!this.val.startDate){
					// Set form validation
					this.state.currentStep = 1;
					this.render();
					return;
				}
			}
			if(step > 2){
				if(!this.val.size){
					// Set form validation
					this.state.currentStep = 2;
					this.render();
					return;
				}
			}
			if(step > 5){
				if(!this.el.form.reportValidity()){
					// Set form validation
					this.state.currentStep = 5;
					this.render();
					return;
				}
			}
		}

		if(delay){
			setTimeout(function () {
				this.actionGoToStep(step);
			}.bind(this), delay)
			return;
		}

		// Do send code
		if(step === 6){
			if(!this.state.isSend){
				let a = this.actionSend();
				a.then(async (res) => {
					if (res.status === 200) {
						this.state.isSend = true;
						this.state.codeSendCount++;
						const result = await res.json();
						this.json.created = result; // needed for link
						if(result.is_login){
							this.openLink(result.link);
						} else {
							this.el.stepList.forEach(step => {
								if(parseInt(step.dataset.step) < 6){
									step.classList.add('is-send');
								}
							})
							this.actionGoToStep(6);
						}
					} else if (res.status >= 500) {
						alert('probeer opnieuw');
					} else {
						const result = await res.json();
						if(result.screen){
							this.panel(errMsg, true);
							errMsg.innerHTML = JSON.stringify(result.screen)
								.replaceAll('"', '')
								.replaceAll(':', ' ')
								.replaceAll('[', '')
								.replaceAll(']', '')
								.replaceAll('{', '')
								.replaceAll('}', '');
						} else {
							alert('check items: ' + res.status);
						}
					}
				}).catch((error) => {
					console.log(error);
				});
				return;
			} else {
				console.log(this.state);
			}
		}

		if(this.state.currentStep > step) {
			this.state.currentStep = step;
			this.render();
		} else{
			this.state.currentStep = step;
			this.render();
		}

		// Scroll to
		let scrollTo = document.querySelector('.is-open');
		if(scrollTo){
			setTimeout(function (){
				window.scrollTo({
					top: scrollTo.getBoundingClientRect().top + window.pageYOffset - 20,
					behavior: 'smooth'
				})
			}, 610); // Need to be after the css transition
		}
	}
	actionCheckCode(){
		let codeErr = document.getElementById('codeErr');
		this.panel(codeErr, false);

		// Code input
		let currentCode = '';
		this.el.codeFieldList.forEach((el,i)=>{
			currentCode += el.value;
		})

		if(currentCode.length !== 6){
			return;
		}

		// Check code
		if(this.state.codeCheckCode === currentCode){
			return;
		}

		// Check call
		fetch('/api/book/code-check', {
			method: 'POST',
			body: JSON.stringify({
				mail: this.el.form.email.value,
				code: currentCode,
				location_id: this.config.locationId,
			}), // Use form data, no json!
			headers: {
				'X-CSRF-TOKEN': this.config.csrf,
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		})
			.then(async r => {
				if(r.status === 200){
					this.openLink(this.json.created.link);
				} else if(r.status >= 500){
					codeErr.innerText = 'Probeer opnieuw (' + r.status + ')';
					this.panel(codeErr, true);
					this.el.codeFieldList[5].value = '';
				}
				else{
					this.state.codeCheckCode = currentCode;
					codeErr.innerText = 'Code ' + currentCode + ' onjuist';
					this.el.codeFieldList.forEach((el,i)=>{el.value = '';});
					this.panel(codeErr, true);
				}
			})
			.catch(e => console.error(e));
	}

	async actionSend(){
		let jsonOb = {
			// Welcome
			location_id: this.config.locationId,
			type_info_id: 8,

			// General type
			start_date: this.val.startDate.toISOString(),
			price_id: this.val.priceId,

			// Account
			email: this.el.form.email.value,
			account_type: this.el.form.account_type.value,
			business_name: this.el.form.business_name.value,
			business_kvk: this.el.form.business_kvk.value,
			first_name: this.el.form.first_name.value,
			last_name: this.el.form.last_name.value,
			mobile: this.el.form.tel.value,
			mobile_country: this.el.form.tel_country.value,
			zipcode: this.el.form.zipcode.value,
			house_number: this.el.form.house_nr.value,
			street: this.el.form.street.value,
			city: this.el.form.city.value,
			// Conform
			// discount_code: this.state.discountCode,
			description: null,
		};

		let csrf = this.config.csrf;
		return await fetch('/api/book2/store', {
			method: 'POST',
			body: JSON.stringify(jsonOb), // Use form data, no json!
			headers: {
				'X-CSRF-TOKEN': csrf,
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		});
	}

	actionResendCode(){
		// todo add check on last send

		return fetch('/api/book/code-resend', {
			method: 'POST',
			body: JSON.stringify({
				mail: this.el.form.email.value,
				location_id: this.config.locationId,
			}), // Use form data, no json!
			headers: {
				'X-CSRF-TOKEN': this.config.csrf,
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		});
	}


	calendar() {
		let config = this;

		const monthNames = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni',
			'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];

		const calTitle = document.getElementById('calTitle');
		const daysGrid = document.getElementById('daysGrid');
		const prevBtn = document.getElementById('prevBtn');
		const nextBtn = document.getElementById('nextBtn');

		const today = new Date();
		today.setHours(0, 0, 0, 0);

		let viewYear = today.getFullYear();
		let viewMonth = today.getMonth();
		let selectedDate = this.val.startDate;

		function isSameDay(a, b) {
			return a && b &&
				a.getFullYear() === b.getFullYear() &&
				a.getMonth() === b.getMonth() &&
				a.getDate() === b.getDate();
		}

		// Monday-first weekday index (0 = Monday ... 6 = Sunday)
		function mondayIndex(jsDay) {
			return (jsDay + 6) % 7;
		}

		function render() {
			calTitle.textContent = monthNames[viewMonth] + ' ' + viewYear;

			const isCurrentMonth = viewYear === today.getFullYear() && viewMonth === today.getMonth();
			isCurrentMonth ? prevBtn.classList.add('disabled') : prevBtn.classList.remove('disabled');
			daysGrid.innerHTML = '';

			const firstOfMonth = new Date(viewYear, viewMonth, 1);
			const startOffset = mondayIndex(firstOfMonth.getDay());
			const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

			for (let i = 0; i < startOffset; i++) {
				const empty = document.createElement('button');
				empty.className = 'empty';
				empty.disabled = true;
				daysGrid.appendChild(empty);
			}

			for (let d = 1; d <= daysInMonth; d++) {
				const cellDate = new Date(viewYear, viewMonth, d);
				const btn = document.createElement('button');
				btn.type = 'button';

				const numSpan = document.createElement('span');
				numSpan.textContent = d;
				btn.appendChild(numSpan);

				if (cellDate < today) {
					btn.disabled = true;
				} else {
					btn.addEventListener('click', function () {
						selectedDate = cellDate;
						config.val.startDate = selectedDate;
						config.actionGoToStep(2);
						render();
					});
				}

				if (isSameDay(cellDate, selectedDate)) {
					btn.classList.add('selected');
					config.val.startDate = selectedDate;
				}
				daysGrid.appendChild(btn);
			}
		}

		prevBtn.addEventListener('click', () => {
			viewMonth--;
			if (viewMonth < 0) {
				viewMonth = 11;
				viewYear--;
			}
			render();
		});

		nextBtn.addEventListener('click', () => {
			viewMonth++;
			if (viewMonth > 11) {
				viewMonth = 0;
				viewYear++;
			}
			render();
		});
		render();
	}

	// Create element
	$(item){return document.querySelector(item);}
	$$(item){return document.querySelectorAll(item);}
	panel(el, show){
		if(!el){
			console.debug('missing el', el, show);
			return;
		}
		if(typeof el === 'string'){
			el = document.querySelector(el);
		}
		el.style.display = show ? '' : 'none';
	}
	openLink(link){
		console.log('Open:', link);
		// Fix issue then book module is in iframe!
		top.window.location.href = link;
	}
	createElCheckbox(inputName, name, under, price){
		let el = document.createElement('label');
		el.classList.add('opt');
		el.innerHTML = `<span class="opt__mark">`
		+ `<input type="checkbox" name="${inputName}" value="1">`
		+ `</span>`
		+ `<span class="opt__info">`
		+ `<span class="opt__t">${name}</span>`
		+ `<span class="opt__d">${under}</span>`
		+ `</span>`
		+ `<span class="opt__p">${price}</span>`;
		return el;
	}

	createElFloor(inputName, inputValue, name, under, price){
		let el = document.createElement('label');
		el.classList.add('opt');
		el.innerHTML = `<span class="opt__mark">`
		+ `<input type="radio" name="${inputName}" value="${inputValue}">`
		+ `</span>`
		+ `<span class="opt__info">`
		+ `<span class="opt__t">${name}</span>`
		+ `<span class="opt__d">${under}</span>`
		+ `</span>`
		+ `<span class="opt__p">${price}</span>`;
		return el;
	}
}

